module.exports = __webpack_public_path__ + "a8c95ee21bf8bc09975135c0c74a1ab2.svg";